import { useQuery } from '@tanstack/react-query';
import { fetchCompanyPeriodRequestsV2 } from '../../../services/queries/KpiCollectionQueries';

export function useCompanyPeriodRequestDataV2() {
  return useQuery({
    queryKey: ['companyPeriodRequestDataV2'],
    queryFn: () => fetchCompanyPeriodRequestsV2(),
  });
}
